export default "__VITE_ASSET__b484c356__"